<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-container fluid>
        <div style="width:100%; padding-top:10px; padding-bottom:10px" class="grey lighten-4">
            <table :class="'font-weight-regular; '+($vuetify.breakpoint.xs ? 'caption' : '')">
                <tr><td>■</td><td>あなたの圃場で管理する品種を設定します。</td></tr>
                <tr><td></td><td>品目→品種の順で登録します。</td></tr>
            </table>
        </div>
        <v-card v-if="crops != null" class="pa-1 mt-1">
            <Title title="品目" dense />
            <v-card-text class="pa-1">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-card @click="onClickAddNewCrop()">
                                <v-card-text>
                                    <v-icon>mdi-plus-circle-outline</v-icon>
                                    新しい品目を登録
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col v-for="crop in crops" :key="crop.body.cropID" cols="12" xs="12" sm="6" md="4" lg="3" xl="3">
                            <v-card @click="onClickCrop(crop)" :color="selectingCrop == crop ? 'cyan lighten-4' : ''">
                                <v-card-text>
                                    <table>
                                        <tr>
                                            <td style="width:100%">{{crop.body.name}}</td>
                                            <td>
                                                <v-btn icon @click.stop="onClickEditCrop(crop)"><v-icon>mdi-pencil</v-icon></v-btn>
                                            </td>
                                        </tr>
                                    </table>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <v-card v-if="selectingCrop != null" class="pa-1 mt-2">
            <Title :title="selectingCrop.body.name+'の品種'" dense />
            <v-card-text class="pa-1">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-card @click="onClickAddNewVariety()">
                                <v-card-text>
                                    <v-icon>mdi-plus-circle-outline</v-icon>
                                    {{selectingCrop.body.name}}の新しい品種を登録
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col v-for="variety in selectingCrop.varieties" :key="variety.varietyID" cols="12" xs="12" sm="6" md="4" lg="3" xl="3">
                            <v-card>
                                <v-card-text>
                                    <table>
                                        <tr>
                                            <td style="width:100%">{{variety.name}}</td>
                                            <td>
                                                <v-btn icon @click.stop="onClickEditVariety(variety)"><v-icon>mdi-pencil</v-icon></v-btn>
                                            </td>
                                        </tr>
                                    </table>                                    
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <v-form ref="cropDialog">
            <v-dialog v-model="isShowCropEditor" persistent v-if="isShowCropEditor">
                <v-card class="pa-1">
                    <Title title="品目" />
                    <v-container>
                        <v-row dense>
                            <v-col>
                                <v-text-field 
                                    v-model="edittingCrop.name" 
                                    clearable 
                                    label="名称" 
                                    outlined 
                                    type="text" 
                                    hint="品目の名前を入力します。(必須)" 
                                    persistent-hint
                                    dense
                                    counter="20"
                                    :rules="[validatorCropNameRequire, validatorCropNameLength]" />
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" @click="onClickCompleteCropEdit">セット</v-btn>
                        <v-btn color="primary" @click="edittingCrop = null">キャンセル</v-btn>
                    </v-card-actions>
                </v-card> 
            </v-dialog>
        </v-form>
        <v-form ref="varietyDialog">
            <v-dialog v-model="isShowVarietyEditor" persistent v-if="isShowVarietyEditor">
                <v-card class="pa-1">
                    <Title :title="selectingCrop.body.name + ' に属する品種'" />
                    <v-container>
                        <v-row dense>
                            <v-col>
                                <v-text-field 
                                    v-model="edittingVariety.name" 
                                    clearable 
                                    label="名称" 
                                    outlined
                                    dense
                                    type="text" 
                                    hint="品種の名前を入力します。(必須)" 
                                    persistent-hint
                                    counter="20"
                                    :rules="[validatorVarietyNameRequire, validatorVarietyNameLength]" />
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" @click="onClickCompleteVarietyEdit">セット</v-btn>
                        <v-btn color="primary" @click="edittingVariety = null">キャンセル</v-btn>
                    </v-card-actions>
                </v-card> 
            </v-dialog>
        </v-form>
    </v-container>
    
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    export default {
        components: {
            Title,
            TitleButton
        },
        data: function (){
            return {
                /** 選択されている品目 */
                selectingCrop: null,
                /** 品目の編集項目 */
                edittingCrop: null,
                /** 品種の編集項目 */
                edittingVariety: null,
                /** 登録されている全品目 */
                crops: [],
                /** 検証 */
                validatorCropNameRequire: value => !!value || '必須入力です。',
                validatorCropNameLength: value => value.length <= 20 || '20文字以内で入力して下さい。',
                validatorVarietyNameRequire: value => !!value || '必須入力です。',
                validatorVarietyNameLength: value => value.length <= 20 || '20文字以内で入力して下さい。',
            }
        },
        created: function () {
            // this.refreshCrops()
            this.crops = this.$store.getters["managementItems/loggedInUserPlaceData"].crops
        },
        computed: {
            userUID: function () {
                return this.$store.getters["userUID"]
            },
            isShowCropEditor: function () {
                if (this.edittingCrop == null) {
                    return false
                }
                return true
            },
            isShowVarietyEditor: function () {
                if (this.edittingVariety == null) {
                    return false
                }
                return true
            },
        },
        methods: {
            /**
             * 品目押下時
             */
            onClickCrop: function (crop) {
                this.selectingCrop = crop
                // this.refreshVarieties(crop)
            },
            /**
             * 新しい品目ボタン押下時
             */
            onClickAddNewCrop: function () {
                var crop = {
                    version:"1.0.0", cropID:0, name:""
                }
                this.edittingCrop = crop
            },
            /**
             * 品目の編集ボタン押下時
             */
            onClickEditCrop: function (targetCrop) {
                var crop = {
                    version:targetCrop.body.version, 
                    cropID:targetCrop.body.cropID, 
                    name:targetCrop.body.name
                }
                this.edittingCrop = crop
            },
            /**
             * 新しい品種ボタン押下時
             */
            onClickAddNewVariety: function () {
                var variety = {
                    version:"1.0.0", 
                    cropID:this.selectingCrop.body.cropID, 
                    varietyID:0, 
                    name:""
                }
                this.edittingVariety = variety
            },
            /**
             * 品種の編集ボタン押下時
             */
            onClickEditVariety: function (targetVariety) {
                var variety = {
                    version:targetVariety.version, 
                    cropID:targetVariety.cropID, 
                    varietyID:targetVariety.varietyID, 
                    name:targetVariety.name
                }
                this.edittingVariety = variety
            },
            /**
             * 品目の編集終了時
             */
            onClickCompleteCropEdit: function () {
                if (!this.$refs.cropDialog.validate()) {
                    return
                }
                const self = this
                if (this.edittingCrop.cropID == 0) {
                    if (this.crops.length == 0) {
                        this.edittingCrop.cropID = 1
                    } else {
                        var maxID = 0
                        for (var index=0; index<this.crops.length; index++){
                            if (this.crops[index].body.cropID > maxID) {
                                maxID = this.crops[index].body.cropID
                            }
                        }
                        this.edittingCrop.cropID = maxID + 1
                    }
                    this.crops.push(
                        {
                            body: this.edittingCrop,
                            varieties: []
                        }
                    )
                } else {
                    const index = this.crops.findIndex((v) => v.body.cropID === this.edittingCrop.cropID)
                    this.crops[index].body = this.edittingCrop
                }
                this.updateCrop({
                    crop:this.edittingCrop,
                    success:null,
                    failed:null
                })
                this.selectingCrop = null
                this.edittingCrop = null
            },
            /**
             * 品種の編集終了時
             */
            onClickCompleteVarietyEdit: function () {
                if (!this.$refs.varietyDialog.validate()) {
                    return
                }
                if (this.edittingVariety.varietyID == 0) {
                    if (this.selectingCrop.varieties.length == 0) {
                        this.edittingVariety.varietyID = 1
                    } else {
                        var maxID = 0
                        for (var index=0; index<this.selectingCrop.varieties.length; index++){
                            if (this.selectingCrop.varieties[index].varietyID > maxID) {
                                maxID = this.selectingCrop.varieties[index].varietyID
                            }
                        }
                        this.edittingVariety.varietyID = maxID + 1
                    }
                    this.selectingCrop.varieties.push(this.edittingVariety)
                } else {
                    const index = this.selectingCrop.varieties.findIndex((v) => v.varietyID === this.edittingVariety.varietyID)
                    this.selectingCrop.varieties.splice(index, 1)
                    this.selectingCrop.varieties.splice(index, 0, this.edittingVariety)
                }
                this.updateVariety({
                    variety:this.edittingVariety,
                    success:null,
                    failed:null
                })
                this.edittingVariety = null
            },
            /**
             * 品目の更新処理
             */
            updateCrop: function (params) {
                // console.log("Variety", "updateCrop")
                const self = this
                db.collection("users").doc(this.userUID).collection("crops").doc(""+params.crop.cropID).set(params.crop).then(function(){
                    self.$store.commit("notification", {message:"登録しました。"})
                    self.$emit("onUpdatedCrop", params.crop)
                    if (params.success != null) params.success()
                }).catch(function(error){
                    self.$store.commit("notification", {message:"登録に失敗しました。", isError: true})
                    if (params.failed != null) params.failed()
                })
            },
            /**
             * 品種の更新処理
             */
            updateVariety: function (params) {
                // console.log("Variety", "updateVariety")
                const self = this
                db.collection("users").doc(this.userUID).collection("crops").doc(""+params.variety.cropID).collection("varieties").doc(""+params.variety.varietyID).set(params.variety).then(function(){
                    self.$store.commit("notification", {message:"登録しました。"})
                    self.$emit("onUpdatedVariety", params.variety)
                    if (params.success != null) params.success()
                }).catch(function(error){
                    self.$store.commit("notification", {message:"登録に失敗しました。", isError: true})
                    if (params.failed != null) params.failed()
                })
            },
        }
    }
</script>